import { apiSlice } from './apiSlice';

export interface PushNotification {
  id: string;
  notification: string;
  scrren: string;
  read: boolean;
  createdAt: string;
  updatedAt: string;
}

interface NotificationsResponse {
  success: boolean;
  message: string;
  notifications: PushNotification[];
  pagination: {
    currentPage: number;
    limit: number;
    totalItems: number;
    totalPage: number;
  };
}

interface UnreadNotificationsResponse {
  success: boolean;
  message: string;
  notifications: PushNotification[];
}

interface ReadAllResponse {
  success: boolean;
  message: string;
}

export const notificationApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getNotifications: builder.query<NotificationsResponse, void>({
      query: () => ({
        url: '/push-notification',
        method: 'GET',
        params: { page: 1, limit: 20 },
      }),
      providesTags: ['GetNotification'],
    }),
    getUnreadNotifications: builder.query<UnreadNotificationsResponse, void>({
      query: () => ({
        url: '/push-notification/unread',
        method: 'GET',
      }),
      providesTags: ['GetNotification'],
    }),
    markAllRead: builder.mutation<ReadAllResponse, void>({
      query: () => ({
        url: '/push-notification/read',
        method: 'POST',
      }),
      invalidatesTags: ['GetNotification'],
    }),
  }),
});

export const { useGetNotificationsQuery, useGetUnreadNotificationsQuery, useMarkAllReadMutation } =
  notificationApi;
